import { useMutation, useQueryClient } from "react-query";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { keys } from "./Keys";
import DataFileImportDataService from "../../services/data-file-import-data-service/DataFileImportDataService";
import { IConfiguration } from "../../services/data-file-import-data-service/Models";

type MutationContextType = {
    previousInstances: IConfiguration[] | undefined;
};

export type UseDeleteDataFileImportConfigurationParams = {
    groupID: number,
} & BaseUseMutationParameters<void, IConfiguration>;

export function useDeleteDataFileImportConfiguration({
    groupID,
    onError,
    onSuccess
}: UseDeleteDataFileImportConfigurationParams) {
    const queryClient = useQueryClient();

    return useMutation<void, RestError, IConfiguration, MutationContextType>(
        async (item) => {
            await DataFileImportDataService.deleteConfiguration(
                groupID,
                item
            );
        },
        {
            onMutate: async (item: IConfiguration) => {

                await queryClient.cancelQueries(keys.all);

                const previousInstances = queryClient.getQueryData<IConfiguration[]>(
                    keys.configurations(
                        groupID
                    )
                );

                queryClient.setQueryData<IConfiguration[]>(
                    keys.configurations(
                        groupID
                    ),
                    (old?: IConfiguration[]) => {
                        return old?.filter(t => t.id !== item.id) ?? [];
                    }
                );

                return {
                    previousInstances
                };
            },
            onError: onError,
            onSuccess: onSuccess,
            onSettled: (_data, error, _runTicket, context) => {

                if (error && context?.previousInstances) {
                    queryClient.setQueryData<IConfiguration[]>(
                        keys.configurations(
                            groupID,
                        ),
                        context?.previousInstances
                    );
                }

                queryClient.invalidateQueries(keys.configurations(groupID));
            }
        }
    );
}
